import React, { useContext, useState, useEffect } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import { Row, Col, Form, Button, Table, Modal } from "react-bootstrap";
import PageLayout from "../../layouts/PageLayout";
import Swal from "sweetalert2";
import { getDolares, crearDolar, actualizarDolar, eliminarDolar } from "../../api/mantenedores.ts";

export default function MantenedorDolarPage() {

    const { t } = useContext(TranslatorContext)
    const [dolares, setDolares] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [formData, setFormData] = useState({
        id: null,
        mes: "",
        anio: new Date().getFullYear(),
        valor: ""
    });

    // Cargar dólares al montar el componente
    useEffect(() => {
        cargarDolares();
    }, []);

    const cargarDolares = async () => {
        setLoading(true);
        try {
            const result = await getDolares();
            if (result.error === false) {
                setDolares(result.data);
            } else {
                Swal.fire("Error", "No se pudieron cargar los dólares", "error");
            }
        } catch (error) {
            console.error("Error al cargar dólares:", error);
            Swal.fire("Error", "Error al cargar dólares", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleOpenModal = (dolar = null) => {
        if (dolar) {
            setFormData({
                id: dolar.id,
                mes: dolar.mes,
                anio: dolar.anio,
                valor: dolar.valor
            });
            setIsEdit(true);
        } else {
            setFormData({
                id: null,
                mes: "",
                anio: new Date().getFullYear(),
                valor: ""
            });
            setIsEdit(false);
        }
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setFormData({
            id: null,
            mes: "",
            anio: new Date().getFullYear(),
            valor: ""
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: name === "valor" ? parseFloat(value) : (name === "mes" ? parseInt(value) : parseInt(value))
        });
    };

    const handleGuardar = async () => {
        if (!formData.mes || !formData.anio || !formData.valor) {
            Swal.fire("Error", "Todos los campos son requeridos", "error");
            return;
        }

        try {
            let result;
            if (isEdit) {
                result = await actualizarDolar(formData.id, formData.valor);
                if (result.error === false) {
                    Swal.fire("Éxito", "Dólar actualizado correctamente", "success");
                    handleCloseModal();
                    cargarDolares();
                } else {
                    Swal.fire("Error", result.msg || "Error al actualizar dólar", "error");
                }
            } else {
                result = await crearDolar(formData.mes, formData.anio, formData.valor);
                if (result.error === false) {
                    Swal.fire("Éxito", "Dólar creado correctamente", "success");
                    handleCloseModal();
                    cargarDolares();
                } else {
                    Swal.fire("Error", result.msg || "Error al crear dólar", "error");
                }
            }
        } catch (error) {
            console.error("Error:", error);
            Swal.fire("Error", "Error al guardar dólar", "error");
        }
    };

    const handleEliminar = async (id) => {
        Swal.fire({
            title: "¿Estás seguro?",
            text: "Esta acción no se puede deshacer",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sí, eliminar"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await eliminarDolar(id);
                    if (res.error === false) {
                        Swal.fire("Éxito", "Dólar eliminado correctamente", "success");
                        cargarDolares();
                    } else {
                        Swal.fire("Error", res.msg || "Error al eliminar dólar", "error");
                    }
                } catch (error) {
                    console.error("Error:", error);
                    Swal.fire("Error", "Error al eliminar dólar", "error");
                }
            }
        });
    };

    const meses = [
        { value: 1, label: "Enero" },
        { value: 2, label: "Febrero" },
        { value: 3, label: "Marzo" },
        { value: 4, label: "Abril" },
        { value: 5, label: "Mayo" },
        { value: 6, label: "Junio" },
        { value: 7, label: "Julio" },
        { value: 8, label: "Agosto" },
        { value: 9, label: "Septiembre" },
        { value: 10, label: "Octubre" },
        { value: 11, label: "Noviembre" },
        { value: 12, label: "Diciembre" }
    ];

    const getMesNombre = (mes) => {
        return meses.find(m => m.value === mes)?.label || "Desconocido";
    };

    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">Mantenedor de Dólar</h3>
                            <ul className="mc-breadcrumb-list">
                                <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link">{t('home')}</Link></li>
                                <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link">Administración</Link></li>
                                <li className="mc-breadcrumb-item">Mantenedor de Dólar</li>
                            </ul>
                        </div>
                    </div>
                </Col>
            </Row>

            <Row className="mb-4">
                <Col xl={12}>
                    <div className="mc-card">
                        <div className="mc-card-header">
                            <h4 className="mc-card-title">Valores del Dólar</h4>
                            <Button 
                                variant="primary" 
                                onClick={() => handleOpenModal()}
                                className="btn-sm"
                            >
                                <i className="material-icons">add</i> Nuevo Dólar
                            </Button>
                        </div>
                        <div style={{ padding: '20px', overflowX: 'auto' }}>
                            {loading ? (
                                <div className="text-center">
                                    <p>Cargando...</p>
                                </div>
                            ) : dolares.length === 0 ? (
                                <div className="text-center">
                                    <p>No hay dólares registrados</p>
                                </div>
                            ) : (
                                <Table hover responsive>
                                    <thead>
                                        <tr>
                                            <th>Mes</th>
                                            <th>Año</th>
                                            <th>Valor</th>
                                            <th>Fecha Ingreso</th>
                                            <th>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {dolares.map((dolar) => (
                                            <tr key={dolar.id}>
                                                <td>{getMesNombre(dolar.mes)}</td>
                                                <td>{dolar.anio}</td>
                                                <td>${dolar.valor.toLocaleString('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                                <td>{new Date(dolar.fechaIngreso).toLocaleDateString('es-CL')}</td>
                                                <td>
                                                    <Button 
                                                        variant="warning" 
                                                        size="sm"
                                                        onClick={() => handleOpenModal(dolar)}
                                                        className="me-2"
                                                    >
                                                        <i className="material-icons">edit</i>
                                                    </Button>
                                                    <Button 
                                                        variant="danger" 
                                                        size="sm"
                                                        onClick={() => handleEliminar(dolar.id)}
                                                    >
                                                        <i className="material-icons">delete</i>
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            )}
                        </div>
                    </div>
                </Col>
            </Row>

            {/* Modal para crear/editar */}
            <Modal show={showModal} onHide={handleCloseModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {isEdit ? "Editar Dólar" : "Nuevo Dólar"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Mes</Form.Label>
                            <Form.Select
                                name="mes"
                                value={formData.mes}
                                onChange={handleInputChange}
                            >
                                <option value="">Seleccionar mes</option>
                                {meses.map((mes) => (
                                    <option key={mes.value} value={mes.value}>
                                        {mes.label}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Año</Form.Label>
                            <Form.Control
                                type="number"
                                name="anio"
                                value={formData.anio}
                                onChange={handleInputChange}
                                min="2020"
                                max={new Date().getFullYear() + 5}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Valor del Dólar</Form.Label>
                            <Form.Control
                                type="number"
                                name="valor"
                                value={formData.valor}
                                onChange={handleInputChange}
                                step="0.01"
                                min="0"
                                placeholder="Ej: 825.50"
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={handleGuardar}>
                        {isEdit ? "Actualizar" : "Crear"}
                    </Button>
                </Modal.Footer>
            </Modal>
        </PageLayout>
    )
}